import { MatTableDataSource } from '@angular/material/table';
import {AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Input, OnInit} from "@angular/core";
import { Component } from "@angular/core";

type ValueType =
  | "Null"
  | "String"
  | "Number"
  | "Boolean"
  | "Array"
  | "Object"
  ;

interface CollapsedEntries {
  [ key: string ]: boolean;
}


@Component({
  selector: 'aw-json-table',
  templateUrl: './json-table.component.html',
  styleUrls: ['./json-table.component.scss']
})
export class JsonTableComponent implements OnInit,AfterViewInit {

  ngOnInit(): void {
      
  }

  public collapsedEntries: CollapsedEntries;
  public entryCount: number;
  public isCollapsed: boolean;
  @Input() value: any;
  @Input() key: any = null;
  public valueType: ValueType;

  // I initialize the json tree component.
  constructor(private changeDetectorRef: ChangeDetectorRef) {
    this.collapsedEntries = Object.create( null );
    this.entryCount = 0;
    this.isCollapsed = false;
    this.value =  ""
    this.valueType = this.calculateType( this.value );
    // this.changeDetectorRef.detectChanges()
  }

  public calculateType( target: any ) : ValueType {

    if ( target === null ) {

      return( "Null" );

    }

    if ( typeof( target ) === "string" ) {

      return( "String" );

    }

    if ( typeof( target ) === "number" ) {

      return( "Number" );

    }

    if ( typeof( target ) === "boolean" ) {

      return( "Boolean" );

    }

    if ( Array.isArray( target ) ) {

      return( "Array" );

    }

    return( "Object" );

  }


  // I get called when the input bindings have been updated.
  public ngOnChanges() : void {

    this.entryCount = 0;
    this.isCollapsed = false;
    this.valueType = this.calculateType( this.value );
    this.clearCollapsedEntries();

    if ( this.valueType === "Object" ) {

      this.entryCount = Object.keys( this.value ).length;

    } else if ( this.valueType === "Array" ) {

      this.entryCount = this.value.length;

    }

  }

  public parseString( event: any ) : void {


    if ( ! event.metaKey ) {

      return;

    }



    try {

      this.value = JSON.parse( this.value );
      this.ngOnChanges();

      console.group( "String Parsing" );
      console.log( "The value was successfully parsed as JSON." );
      console.log( this.value );
      console.groupEnd();

    } catch ( error ) {

      console.group( "String Parsing" );
      console.warn( "The value could not be parsed as JSON." );
      console.error( error );
      console.log( this.value );
      console.groupEnd();

    }

  }


  // I toggle the expansion of the given value.
  public toggle( index?: string | number ) : void {

    // Top-level toggle.
    if ( index === undefined ) {

      this.isCollapsed = ! this.isCollapsed;

      // If we're collapsing the top-level value, then reset any settings for the
      // sub-entry visibility.
      if ( this.isCollapsed ) {

        this.clearCollapsedEntries();

      }

      // Sub-entry toggle.
    } else {

      this.collapsedEntries[ index ] = ! this.collapsedEntries[ index ];

    }

  }

  // ---
  // PRIVATE METHODS.
  // ---

  // I clear the collapsed entries index.
  private clearCollapsedEntries() : void {

    for ( var key in this.collapsedEntries ) {

      delete( this.collapsedEntries[ key ] );

    }

  }

  ngAfterViewInit(): void {
  }

  updateData(apiResponse:any):void{
    this.collapsedEntries = Object.create( null );
    this.entryCount = 0;
    this.isCollapsed = false;
    this.value =  apiResponse
    console.log(this.value );
    this.valueType = this.calculateType( this.value );
    // this.changeDetectorRef.detectChanges()

  }
  assertStringKey(key: unknown): string {
    return key as string;
  }

  
  
}
